"use client"

import { useState } from "react"
import Win95Button from "../Win95Button"
import PasswordField from "./PasswordField"

type ChatAuthFormProps = {
	onAuthed: (username: string) => void
}

type Mode = "login" | "register"

export default function ChatAuthForm({ onAuthed }: ChatAuthFormProps) {
	const [mode, setMode] = useState<Mode>("login")
	const [username, setUsername] = useState("")
	const [password, setPassword] = useState("")
	const [error, setError] = useState<string | null>(null)
	const [submitting, setSubmitting] = useState(false)

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault()
		setError(null)
		setSubmitting(true)
		try {
			const res = await fetch(`/api/trashchat/${mode === "login" ? "login" : "register"}`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ username, password }),
			})
			const data = await res.json()
			if (!res.ok) {
				setError(data.error ?? "Something went wrong.")
				return
			}
			onAuthed(data.username as string)
		} catch {
			setError("Network error. Try again.")
		} finally {
			setSubmitting(false)
		}
	}

	return (
		<form
			onSubmit={handleSubmit}
			className="
				w-full max-w-xs mx-auto
				bg-[#0d0020]
				border-2 border-t-[#00f5ff] border-l-[#00f5ff] border-b-[#ff003c] border-r-[#ff003c]
				p-3 flex flex-col gap-2
				shadow-[0_0_14px_rgba(191,0,255,0.5)]
			"
		>
			<div className="text-center text-[#39ff14] font-bold text-sm [text-shadow:0_0_6px_#ff003c]">
				{mode === "login" ? "LOG IN TO POST" : "REGISTER TO POST"}
			</div>

			<label className="text-xs font-bold text-[#00f5ff]">
				Username
				<input
					value={username}
					onChange={(e) => setUsername(e.target.value)}
					required
					autoComplete="username"
					className="mt-1 w-full bg-black text-[#39ff14] border-2 border-t-[#ff003c] border-l-[#ff003c] border-b-[#00f5ff] border-r-[#00f5ff] px-2 py-1 text-sm outline-none"
				/>
			</label>

			<PasswordField
				label="Password"
				value={password}
				onChange={setPassword}
				required
				autoComplete={mode === "login" ? "current-password" : "new-password"}
			/>

			{error && <div className="text-xs text-[#ff003c] font-bold">{error}</div>}

			<Win95Button label={submitting ? "..." : mode === "login" ? "Log In" : "Create Account"} />

			<button
				type="button"
				onClick={() => {
					setMode(mode === "login" ? "register" : "login")
					setError(null)
				}}
				className="text-xs text-[#ffe600] underline underline-offset-2 hover:text-[#ff2d78]"
			>
				{mode === "login" ? "Need an account? Register" : "Already have an account? Log in"}
			</button>
		</form>
	)
}
